import $ from 'cash-dom';

import "./core/core";

// import Modal from 'bootstrap/js/src/modal';
// import 'bootstrap/js/src/tab'; //rev
// import 'bootstrap/js/src/button';

// import 'bootstrap/js/src/popover';

//eslint-disable 
//import 'expose-loader?Tether!tether';
// import 'bootstrap/dist/js/bootstrap.min';

// import 'bootstrap/js/src/dropdown';
// import 'bootstrap/js/src/collapse';
// import "./bootstrap/collapse";
import "@itank/playground/utils/bootstrap"
// import 'bootstrap/js/src/popover';
// import 'flexibility';
console.log("selectors");
import './selectors.js';

import './responsive.js'; //disable responsive js , handle in
// import './../../classic/_dev/js/checkout';
// import './../../classic/_dev/js/customer';
// import './../../classic/_dev/js/listing';
// import './../../classic/_dev/js/product';
// import './../../classic/_dev/js/cart';

import prestashop from 'prestashop';

prestashop.themeSelectors.product.cover='cover-disabled';
prestashop.themeSelectors.product.selected='cover-disabled';
prestashop.themeSelectors.product.thumb='cover-disabled';
prestashop.themeSelectors.product.tabs='tab-disabled';
prestashop.themeSelectors.product.imagesModal='modal-disabled';
prestashop.themeSelectors.product.thumbContainer='thumb-disabled';
prestashop.themeSelectors.product.modalProductCover='modal-disabled';

import EventEmitter from 'events';
import DropDown from './bootstrap/dropdown.js';

// import Form from './../../classic/_dev/js/components/form';
// import ProductMinitature from './../../classic/_dev/js/components/product-miniature';
// import ProductSelect from './../../classic/_dev/js/components/product-select';
// import TopMenu from './old/top-menu';
import "./top-menu.js";

// import './../../classic/_dev/js/lib/bootstrap-filestyle.min';
// import './../../classic/_dev/js/lib/jquery.scrollbox.min';



// eslint-enable 

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
    if (!prestashop[i]) {
     prestashop[i] = EventEmitter.prototype[i];
    }
}

 import './block-cart.js';


// var dbg=document.documentElement.getAttribute("data-debug"); 
if(window.dbg) console.log('lucid up');
import "./lucid";

// import "../../prestalib/js/prestalib.js";
// import "../../superlayout/js/superlayout.js";
// import "../../superlayout/js/pagecache.js";
// import "../../playermod/js/playermod.js";
// import "../../minslider/js/minslider.js";
// import "../../mfpremote/js/mfpremote.js";
import "./modules/newsletter.js";


